import { render, staticRenderFns } from "./FreeTextContent.vue?vue&type=template&id=1cd838d2"
import script from "./FreeTextContent.vue?vue&type=script&lang=ts"
export * from "./FreeTextContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports